import { useMutationDispatchNote } from '@/hooks/orderhistory.hook';
import { Button } from '../components';
import { SpinnerBox } from './spinner-box';
import { useDispatchNotePDF } from '@/hooks/pdf.hook';
import { SearchStatus } from '@/types/order-management';
import dayjs from 'dayjs';
import { useAppStore } from '@/store/app-store';
import { useContext } from 'react';
import LanguageContext from '@/context/language';
import clsx from 'clsx';

function DispatchNotePdf({
  orderNumber,
  status,
  children,
  className,
}: {
  orderNumber: string;
  status: SearchStatus;
  children?: React.ReactNode;
  className?: string;
}) {
  const { configByCountry } = useAppStore();
  const { lang } = useContext(LanguageContext);

  const { mutateAsync: asyncDispatchNote, isLoading: dispatchNoteLoading } = useMutationDispatchNote();
  const { mutateAsync: asyncDispatchNotePDF, isLoading: dispatchNotePdfLoading } = useDispatchNotePDF();

  if (status !== 'Shipped' || !configByCountry?.isShowDispatchNoteInOrder) return null;

  const onClickDispatchNote = async () => {
    const dispatchResponse = await asyncDispatchNote(orderNumber);
    if (!dispatchResponse?.data) return;
    const { url, type } = await asyncDispatchNotePDF({
      data: dispatchResponse.data,
      lang,
    });
    const a = document.createElement('a');
    a.href = url;
    if (type === 'pdf') {
      a.download = `dispatchNote_${orderNumber}.pdf`;
    } else if (type === 'zip') {
      const currentTime = dayjs().format('YYYYMMDDHHmmss');
      a.download = `dispatchNote_${currentTime}.zip`;
    }
    a.click();
  };

  return (
    <SpinnerBox isLoading={dispatchNoteLoading || dispatchNotePdfLoading}>
      <Button
        type="outline"
        className={clsx('p-0 w-full', className)}
        onClick={onClickDispatchNote}
        disabled={!orderNumber}
      >
        {children}
      </Button>
    </SpinnerBox>
  );
}

export { DispatchNotePdf };
